import Block from './Block'

export default class ImageBlock extends Block {

    constructor(blockRoot) {
        super(blockRoot)

        this.contentBody = this.root.find('.image-block__content-body')
        this.contentButtons = this.root.find('.image-block__content-buttons')
        // this.contentMore = this.root.find('.cbutton--more')
        // this.contentLess = this.root.find('.cbutton--less')
        this.maxContentHeight = Number.parseInt(this.root.data('max-content-height')) || 360


        // this.contentMore.on('click', event => {
        //     event.preventDefault()
        //     this.showLessButton().contentUnfurl()
        // })
        // this.contentLess.on('click', event => {
        //     event.preventDefault()
        //     this.showMoreButton().contentFurl()
        // })

//    $(window).load(this.adapt.bind(this));
//    setTimeout(this.adapt.bind(this), 500);

//    $(window).on("resize", event => {
//      this.adapt();

//      setTimeout(this.adapt.bind(this), 500);
//    });
        $(document).ready(function() {
            $('#image-block-submit').click(function() {
                window.location.href = '/bostader?city=' + $('#image-block-cities')
                    .val() + '&area=' + $('#image-block-cities2').val()
            })
            $('#image-block-cities').change(function() {
                $.ajax({
                    url: ajaxurl,
                    method: 'POST',
                    data: {
                        action: 'updateCities',
                        parent_id: $(this).val(),
                    },
                    success: function(response) {
                        if (typeof response.success !== 'undefined' && response.success) {
                            if (response.cities.length > 0) {
                                $('#image-block-cities2').empty()
                                for (var i = 0; i < response.cities.length; i++) {
//								$('#image-block-cities2').append('<option>test</option>');
                                    let option = $('<option></option>').attr('value', response.cities[i].term_id)
                                        .text(response.cities[i].name)
                                    $('#image-block-cities2').append(option)
                                }
                                $('#image-block-cities2').prop('disabled', false).removeClass('disabled')
                                $('#image-block-submit').prop('disabled', false).removeClass('disabled')
                            }
                        } else {
                            let option = $('<option>Område</option>')
                            $('#image-block-cities2').empty()
                            $('#image-block-cities2').append(option)
                            $('#image-block-cities2').prop('disabled', true).addClass('disabled')
                            $('#image-block-submit').prop('disabled', true).addClass('disabled')
                        }
                    },
                })
            })
        })
    }
}
